<loader *ngIf="loading"></loader>

<ui-table
  *ngIf="data"
  [data]="data"
  [isWrapped]="false"
  [tblColor]="true"
  [tblRoundBottom]="true"
  (requestUpdate)="loadDataOnPagination($event)"
  [totalRecords]="searchMetaData.totalRecords"
  [numberOfRows]="numberOfRows"
  [displayFilter]="['invId', 'invDateFormatted']"
  [templates]="[
    {
      title: 'translate.general.invHaktzaa',
      template: invHaktzaa,
      afterColumn: 0,
      permission: true
    },
    {
      title: 'translate.general.clinic',
      template: clinicDescr,
      permission: !clinicUserSw
    },
    {
      title: 'translate.general.invTotSum',
      template: invTotSum
    },
    {
      title: 'translate.reports.viewDocument',
      template: viewPdf
    }
  ]"
></ui-table>

<ng-template #invTotSum let-row="row">
  <span *ngIf="row.invTotSum" class="l-num">{{
    row.invTotSum | currency: "ILS"
  }}</span>
</ng-template>

<ng-template #invHaktzaa let-row="row">
  <span *ngIf="row.invHaktzaa" class="l-num">{{ row.invHaktzaa }}</span>
</ng-template>

<ng-template #invRemainingSum let-row="row">
  <span
    class="l-ltr l-ta-right"
    style="direction: ltr"
    *ngIf="row.invRemainingSum"
  >
    {{ row.invRemainingSum }}</span
  >
</ng-template>

<ng-template #viewPdf let-row="row">
  <div>
    <spinner *ngIf="row.docLoading"></spinner>
    <i
      *ngIf="!row.docLoading"
      class="icon-view-doc t-pointer fas fa-file-pdf c-success"
      (click)="onRowSelect(row)"
    ></i>
  </div>
</ng-template>

<ng-template #clinicDescr let-row="row">
  {{ row.clinicDescr }}
</ng-template>
